import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AuthState} from "./auth.state";

export const selectAuthState =
  createFeatureSelector<AuthState>('auth')


export const selectToken = createSelector(
  selectAuthState,
  (authState: AuthState) => authState.token
);

export const selectUser = createSelector(
  selectAuthState,
  (authState: AuthState) => authState.user
);

export const selectIsAuth = createSelector(
  selectAuthState,
  (authState: AuthState) => !!authState.token
)

export const selectError = createSelector(
  selectAuthState,
  (authState: AuthState) => authState.error
)

